import BaseLifecycleListener from './BaseLifecycleListener'

export default class FallbackLifecycleListener extends BaseLifecycleListener<any, any> {}
